import { Sort } from '@angular/material/sort';

export class QueryIndexCompleted {
  static readonly type = '[Query] Query Index Completed';
  constructor(public id: number) {}
}

export class FilterChange {
  static readonly type = '[Category] FilterChange';
  constructor(public filters: any) {}
}

export class SorterChange {
  static readonly type = '[Category] SorterChange';

  constructor(public sort: Sort) {}
}

export class GroupByChange {
  static readonly type = '[Category] GroupByChange';
  constructor(public key: string, public selectedGroupId: number) {}
}
